import { render, staticRenderFns } from "./AddMedicineView.vue?vue&type=template&id=84ca8406"
import script from "./AddMedicineView.vue?vue&type=script&lang=js"
export * from "./AddMedicineView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports